module.exports = __webpack_public_path__ + "img/section5_pic1@3x.33bed1f3.png";